<template>
    <div>
        <v-app-bar id="nav-bar" app class="primary" dark min-width="100vw">
            <div id="left-side-container">
                <v-icon v-if="sessionValid" @click="openCancelModal">$times</v-icon>
                <v-toolbar-title id="applicant-title" class="px-4 d-none d-sm-block">
                    <h4>{{ applicantTitle }}</h4>
                </v-toolbar-title>
            </div>
            <div id="logo-container">
                <AspenLogo v-if="stateLogoCheck" />
            </div>
            <div id="faq-button-container">
                <v-icon id="faq-button" @click.stop="showContextHelp = !showContextHelp"
                    >$vuetify.icon.questionCircle</v-icon
                >
            </div>
        </v-app-bar>
        <CancelFlowModal :show-modal="showCancelModal" @close="closeCancelModal" />
        <FAQDrawer v-model="showContextHelp" />
    </div>
</template>

<script>
    import AspenLogo from "@/components/branding/AspenLogo.vue"
    import { helpService } from "@/service"
    import { applicationState, sessionState } from "@/state"
    import { mapGetters, mapState } from "vuex"
    import CancelFlowModal from "@/components/modal/CancelFlowModal.vue"
    import FAQDrawer from "@/components/drawer/FAQDrawer.vue"
    import SessionState from "@/state/SessionState"

    export default {
        name: "NavBar",
        components: {
            FAQDrawer,
            AspenLogo,
            CancelFlowModal,
        },
        data: () => ({
            application: applicationState.application,
            eduDrawer: false,
            mainDrawer: false,
            glossaryEntries: [],
            mainGroup: null,
            showContextHelp: false,
        }),

        computed: {
            ...mapGetters(["applicantInfo"]),

            ...mapState("session", {
                sessionValid: state => !!state.data.dynamicProviderKey?.providerKey,
                showCancelModal: state => {
                    return state.showCancelModal
                },
            }),

            applicantTitle() {
                let title = ""

                if (this.applicantInfo.firstName) {
                    title += this.applicantInfo.firstName
                }

                if (this.applicantInfo.lastName) {
                    if (title) title += " "
                    title += this.applicantInfo.lastName
                }

                if (this.applicantInfo.id) {
                    if (title) title += " : "
                    title += this.applicantInfo.id
                }

                return title
            },

            stateLogoCheck() {
                const noLogoStates = ["IL"]
                return !noLogoStates.some(noLogoState => SessionState?.session?.properties?.state === noLogoState)
            },
        },

        watch: {
            mainGroup() {
                this.drawer = false
            },
        },

        created() {
            helpService.findGlossaryEntries().then(({ entries }) => (this.glossaryEntries = entries))
        },

        methods: {
            goBack() {
                return this.$router.go(-1)
            },
            openCancelModal() {
                sessionState.openCancelModal()
            },
            closeCancelModal() {
                sessionState.closeCancelModal()
            },
        },
    }
</script>

<style lang="scss" scoped>
    #nav-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100vw;
    }

    @media only screen and (min-width: 960px) {
        #faq-button {
            display: none;
        }
    }

    @media only screen and (max-width: 960px) {
        #applicant-title {
            display: none !important;
        }
    }

    .navigation-drawer {
        width: 560px !important;
        position: fixed;
        top: 0;
        right: 0;
        overflow-y: scroll;
    }

    #left-side-container {
        display: flex;
        justify-content: space-between;
    }

    .qrcode {
        margin: auto;
        max-width: 250px;
    }
</style>
